import { GameType } from '../../games'
import { NewsCategory, NewsItem } from '../home'

export enum BlogModule {
  Custom,
  Title,
  Subtitle,
  Paragraph,
  Image,
}

export interface BlogData {
  key: string
  title: string
  tag: NewsCategory
  date: string
  game: GameType
  content: {
    type: BlogModule
    value: unknown
  }[]
  more: NewsItem[]
  path: string
}
